import { SvgSprite } from '../classes/svgLoader';
import { mainNavigation } from '../classes/main-navigation';
import { nodeListToArray } from '../helpers/nodeListToArray';
import { Tabs } from '../classes/tabs';
import { queryToggler } from '../classes/query-toggler';
import { addToDataLayer } from '../classes/data-layer';
import { LandingCarousels } from '../classes/landing-carousel-init';

(() => {
    new SvgSprite('/Static/img/sprite.svg');

    const navigationInit = () => {
        if (mainNavigation) mainNavigation.init();
    }

    //Landing Page Carousels
    const landingCarouselContainers = nodeListToArray(document.querySelectorAll('[data-landingcarousel-container]'));
    new LandingCarousels(landingCarouselContainers);
    // Tabs
    const tabs = nodeListToArray(document.querySelectorAll('[data-tabs-container]'));
    tabs.forEach(tabGroup => {
        new Tabs({ container: tabGroup as HTMLElement });
    });

    // Handle opening Accordion/Tabs via query string, adding to GTM on click
    const panels = nodeListToArray(document.querySelectorAll('[data-panel-container]'));
    panels.forEach(panel => {
        new queryToggler(panel);
        new addToDataLayer(panel)
    })
    navigationInit();

    
})();